module.exports = __webpack_public_path__ + "static/media/receipt.697fb2fb.svg";